export function setAccount(state, payload) {
  state.account = payload;
}
export function setUserAccount(state, payload) {
  state.user = payload;
}
